export const schoolFormEstablishmentTypes = [
  { value: 'college', label: 'Collèges' },
  { value: 'LEGT', label: 'LEGT' },
  { value: 'LP', label: 'LP' },
  { value: 'LPO', label: 'LPO' },
  { value: 'agricole', label: 'Agricoles' },
];

export const otherGroupsFormEstablishmentTypes = [
  { value: 'CFA', label: 'CFA' },
  { value: 'MFR', label: 'MFR' },
  {
    value: 'mission-locale',
    label: 'Missions locales',
  },
  {
    value: 'association',
    label: 'Associations',
  },
  {
    value: 'E2C',
    label: 'E2C',
  },
  {
    value: 'autre',
    label: 'Autres écoles',
  },
];

export const typeOfAcademyOptions = [
  { value: 'Nancy-Metz', label: 'Nancy-Metz' },
  { value: 'Reims', label: 'Reims' },
  { value: 'Strasbourg', label: 'Strasbourg' },
];

export const distanceInKmOptions = [
  { value: 'lessThan30', label: 'Moins de 30 km' },
  { value: '31To60', label: '31 à 60 km' },
  { value: '61To90', label: '61 à 90 km' },
  { value: '91To120', label: '91 à 120 km' },
  { value: 'moreThan120', label: 'Plus de 120 km' },
];

export const typeQuries = {
  specializedEstablishment: `(libelle_nature="COLLEGE" OR libelle_nature="COLLEGE CLIMATIQUE" OR libelle_nature="COLLEGE SPECIALISE" OR libelle_nature="ECOLE SECONDAIRE SPECIALISEE (2 D CYCLE)" 
      OR libelle_nature="ECOLES COMPOSEES UNIQT DE STS ET OU CPGE" 
      OR libelle_nature="ETAB REGIONAL/LYCEE ENSEIGNEMENT ADAPTE" 
      OR libelle_nature="ETABLISSEMENT DE REINSERTION SCOLAIRE" 
      OR libelle_nature="ETABLISSEMENT MEDICO-EXPERIMENTAL" 
      OR libelle_nature="ETABLISSEMENT POUR DEFICIENTS AUDITIFS" 
      OR libelle_nature="ETABLISSEMENT POUR DEFICIENTS VISUELS" 
      OR libelle_nature="ETABLISSEMENT POUR INFIRMES MOTEURS" 
      OR libelle_nature="ETABLISSEMENT POUR POLY-HANDICAPES" 
      OR libelle_nature="ETABLISSEMENT POUR SOURDS-AVEUGLES")
      OR type_etablissement="EREA"`,
  college:
    '(libelle_nature="COLLEGE" OR libelle_nature="COLLEGE CLIMATIQUE" OR libelle_nature="COLLEGE SPECIALISE")',
  LGT: `(
        libelle_nature="LYCEE CLIMATIQUE" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT GENERAL" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT TECHNOLOGIQUE"
        OR libelle_nature="LYCEE ENSEIGNT GENERAL ET TECHNOLOGIQUE"
        OR libelle_nature="LYCEE EXPERIMENTAL"
        OR libelle_nature="SECTION ENSEIGT GENERAL ET TECHNOLOGIQUE")
        `,
  LEGT: `(
        libelle_nature="LYCEE CLIMATIQUE" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT GENERAL" 
        OR libelle_nature="LYCEE D ENSEIGNEMENT TECHNOLOGIQUE"
        OR libelle_nature="LYCEE ENSEIGNT GENERAL ET TECHNOLOGIQUE"
        OR libelle_nature="LYCEE EXPERIMENTAL"
        OR libelle_nature="SECTION ENSEIGT GENERAL ET TECHNOLOGIQUE")
        `,
  LP: '(libelle_nature="LYCEE PROFESSIONNEL")',
  LPO: '(libelle_nature="LYCEE POLYVALENT" OR libelle_nature="SECTION D ENSEIGNEMENT PROFESSIONNEL")',

  // Elementary School
  elementarySchool: '(ecole_elementaire="1")',

  // Agriculture School
  agricole:
    '((ministere_tutelle="AGRICULTURE" AND type_etablissement="Lycée") OR (ministere_tutelle="AGRICULTURE" AND type_etablissement="Autre"))',
  autre: '(ministere_tutelle="AGRICULTURE" AND type_etablissement="Autre")',
};

export const classLevels = [
  { value: '6eme', label: '6ème' },
  { value: '5eme', label: '5ème' },
  { value: '4eme', label: '4ème' },
  { value: '3eme', label: '3ème' },
  { value: 'seconde', label: 'Seconde' },
  { value: 'premiere', label: 'Première' },
  { value: 'terminale', label: 'Terminale' },
  { value: 'cap-1ere-annee', label: 'CAP 1ère année' },
  { value: 'cap-2eme-annee', label: 'CAP 2ème année' },
  { value: 'bts-1ere-annee', label: 'BTS 1ère année' },
  { value: 'bts-2eme-annee', label: 'BTS 2ème année' },
  { value: 'other', label: 'Autres' },
];

export const visitDays = [
  { value: 'thu', label: 'Je 04.02' },
  { value: 'fri', label: 'Ve 05.02' },
];

export const arrivalTimes = {
  thu: [
    { value: '09h00 - 09h30', label: '09h00 - 09h30', slots: 45 },
    { value: '09h30 - 10h00', label: '09h30 - 10h00', slots: 45 },
    { value: '10h00 - 10h30', label: '10h00 - 10h30', slots: 45 },
    { value: '10h30 - 11h00', label: '10h30 - 11h00', slots: 45 },
    { value: '11h00 - 11h30', label: '11h00 - 11h30', slots: 35 },
    { value: '11h30 - 12h00', label: '11h30 - 12h00', slots: 35 },
    { value: '12h00 - 12h30', label: '12h00 - 12h30', slots: 35 },
    { value: '12h30 - 13h00', label: '12h30 - 13h00', slots: 35 },
    { value: '13h00 - 13h30', label: '13h00 - 13h30', slots: 35 },
    { value: '13h30 - 14h00', label: '13h30 - 14h00', slots: 35 },
  ],
  fri: [
    { value: '09h00 - 09h30', label: '09h00 - 09h30', slots: 45 },
    { value: '09h30 - 10h00', label: '09h30 - 10h00', slots: 45 },
    { value: '10h00 - 10h30', label: '10h00 - 10h30', slots: 45 },
  ],
};

export const departureTimes = {
  thu: [
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
    { value: '14h00 - 14h30', label: '14h00 - 14h30' },
    { value: '14h30 - 15h00', label: '14h30 - 15h00' },
    { value: '15h00 - 15h30', label: '15h00 - 15h30' },
    { value: '15h30 - 16h00', label: '15h30 - 16h00' },
    { value: '16h00 - 16h30', label: '16h00 - 16h30' },
    { value: '16h30 - 17h00', label: '16h30 - 17h00' },
  ],
  fri: [
    { value: '11h00 - 11h30', label: '11h00 - 11h30' },
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
  ],
};

export const picnicTimeSlots = {
  thu: [
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    { value: '13h00 - 13h30', label: '13h00 - 13h30' },
    { value: '13h30 - 14h00', label: '13h30 - 14h00' },
  ],
  fri: [
    { value: '11h30 - 12h00', label: '11h30 - 12h00' },
    { value: '12h00 - 12h30', label: '12h00 - 12h30' },
    { value: '12h30 - 13h00', label: '12h30 - 13h00' },
    // { value: '13h00 - 13h30', label: '13h00 - 13h30' },
  ],
};

export const modesOfTransport = [
  { value: 'publicTransport', label: 'MET (transport en commun de la ville de Metz)' },
  { value: 'busOrCoachesPrivate', label: 'Bus' },
  { value: 'Train', label: 'Train' },
  { value: 'covoiturage', label: 'Covoiturage' },
  { value: 'other', label: 'Autres' },
];

export const tourTypes = [{ value: 'introduction', label: 'Introduction à la visite' }];

export const NUMBER_OF_TOUR_STUDENTS = {
  introduction: { MIN: 1, MAX: 500 },
};

export const FINAL_BOOKING_TIME = new Date('2026-11-30T22:59:00Z'); // 30 Nov 11:59PM CET
export const FINAL_EDIT_TIME = new Date('2026-12-18T23:00:00Z'); // 18 Dec midnight CET
// export const FINAL_BOOKING_TIME = new Date('2025-10-09T13:41:55.704Z'); // test

export const getTimeRangeStartMinutes = (range) => {
  if (!range || typeof range !== 'string') return null;
  const start = range.split(' - ')[0];
  const [hours, minutes] = start.split('h').map((part) => Number(part));
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
  return hours * 60 + minutes;
};

export const isDepartureAfterArrival = (arrivalTime, departureTime) => {
  const arrivalStart = getTimeRangeStartMinutes(arrivalTime);
  const departureStart = getTimeRangeStartMinutes(departureTime);
  if (arrivalStart == null || departureStart == null) return false;
  return departureStart > arrivalStart;
};

export const timeSlots = Object.fromEntries(
  Object.entries(arrivalTimes).map(([day, times]) => [
    day,
    {
      introduction: Object.fromEntries(
        times.filter((time) => time.slots).map((time) => [time.value, time.slots]),
      ),
    },
  ]),
);
